import { render } from "./TabValidacion.vue?vue&type=template&id=6960593d&scoped=true"
import script from "./TabValidacion.vue?vue&type=script&lang=js"
export * from "./TabValidacion.vue?vue&type=script&lang=js"

import "./TabValidacion.vue?vue&type=style&index=0&id=6960593d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6960593d"]])

export default __exports__